import { render } from "./HarpColorsView.vue?vue&type=template&id=163567b0"
import script from "./HarpColorsView.vue?vue&type=script&lang=js"
export * from "./HarpColorsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__